import { ensureArray } from "@thi.ng/arrays";
import { isArray, isString } from "@thi.ng/checks";
import { str } from "../rfn/str";
import { concat } from "./concat";
import { reverse } from "./reverse";
export function palindrome(x) {
    return isString(x)
        ? str("", concat([x], reverse(x)))
        : isArray(x)
            ? x.concat(x.slice().reverse())
            : ((x = ensureArray(x)), concat(x, reverse(x)));
}
